jQuery(document).ready(function(){
  console.log("I am ready!");
  var $window = $(window);
  var windowsize = $window.width();
  var lastScrollTop = 0;
  var statusData = "empty";
  if(windowsize > 990){
    $(window).scroll(function(event){
    var st = $(this).scrollTop();
    var title = 0;
    var prod_text = 0;
    var prod_variation = 0;
    var lastcount = 0;
    if(title !== '' && title !== null){
      title = $('.product__title').height();
      lastcount = lastcount + title;
    }
    if(prod_text !== '' && prod_text !== null){
     prod_text = $('.product__text.caption-with-letter-spacing').height();
      lastcount = lastcount + prod_text;
    }
    if(prod_variation !== '' && prod_variation !== null){
      prod_variation = $('variant-radios.no-js-hidden').height();
      lastcount = lastcount + prod_variation;
    }
      if(lastcount === 0){
        lastcount  = 330;
      }
   if (st > lastScrollTop){
       // downscroll code
     if(!$('.cm-product-info-wrapper').hasClass('active-sticky-wrap')){
        $('.cm-product-info-wrapper').addClass("active-sticky-wrap");
     }
     if($('.cm-product-info-wrapper').hasClass('active-sticky-wrap')){
      if(statusData === "empty"){
       $('.active-sticky-wrap').animate({
        top: `-${lastcount}px`,
        }, 1200);
       statusData = "done";
       console.log("SCroll Down animate");
     } 
     }
      
   } else {
      // upscroll code
     if(st < 100){
       $('.cm-product-info-wrapper').removeClass("active-sticky-wrap"); 
       $('.cm-product-info-wrapper').removeAttr('style') ;
     }
     if(statusData === "done"){
        //$('.cm-product-info-wrapper').css('top','0px');
       $('.active-sticky-wrap').animate({
        top: '80px',
        }, 1200);
       statusData = "empty";
       console.log("SCroll up animate");
     }
     
   }
   lastScrollTop = st;
});
}
})